/** 로그인한 사용자로 저장소 자리의 소유자를 판정한다 — 판정은 storageOwnerOf 하나(여기는 호출자를 로그인 상태에서 읽기만 한다) */
import { useAuthStore } from '@/app/stores/authStore';
import { storageOwnerOf, type StorageOwner } from './storageOwner';

export const storageOwner = (action: string, project?: { user_id?: string | null } | null): StorageOwner =>
  storageOwnerOf(useAuthStore.getState().user?.id, action, project);
